<template>
  <component :is="listTag" :class="listClassList">
    <ArticleContentRenderer v-if="children" :content="children" :preloaded-data="preloadedData" />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import ArticleContentRenderer from './ArticleContentRenderer.vue';

import type { PreloadedData } from './lib/articleComponents';
import type { ArticleContent } from './models/ArticleContent';

export interface Props {
  children?: ArticleContent;
  preloadedData?: PreloadedData;
  ordered?: boolean;
  tight?: boolean;
}

const props = defineProps<Props>();

const listTag = computed(() => {
  return props.ordered ? 'ol' : 'ul';
});

const listClassList = computed(() => {
  return props.tight ? ['article-content-list', 'article-content-list--tight'] : ['article-content-list'];
});
</script>

<style lang="scss" scoped>
ul.article-content-list,
ol.article-content-list {
  box-sizing: border-box;
  max-width: var(--width-content);
  padding-left: var(--alias-space-40, 40px);
  margin: 8px 0 0;
  font-size: 17px;
  line-height: 24px;
}

ul.article-content-list {
  list-style-type: disc;
}

ol.article-content-list {
  list-style-type: decimal;
}

.article-content-list--tight {
  :deep(li + li) {
    margin-top: 0;
  }
}
</style>
